<template>
	<div class="home">
		<div class="banner">
			<div class="in">
				<img class="icon1" src="@/assets/images/banner_icon_1.png"/>
				<img class="icon2" src="@/assets/images/banner_icon_2.png"/>
				<img class="icon3" src="@/assets/images/banner_icon_3.png"/>
				<img class="icon4" src="@/assets/images/banner_icon_4.png"/>
				<img class="icon5" src="@/assets/images/banner_icon_5.png"/>
				<div class="btn ios" @click="download('ios')">
					<img src="@/assets/images/apple.png"/>
					<div class="text">
						<span class="t1">Download on the</span>
						<span class="t2">App Store</span>
					</div>
				</div>
				<div class="btn android" @click="download('android')">
					<img src="@/assets/images/android.png"/>
					<div class="text">
						<span class="t1">Download it from</span>
						<span class="t2">Android Market</span>
					</div>
				</div>
			</div>
		</div>
		
		<div class="box-1">
			<div class="title-box">
				<img src="@/assets/images/title_1.png"/>
			</div>
			
			<div class="card-box">
				<div class="card">
					<div class="info">
						<img class="icon" src="@/assets/images/home_icon_1.png"/>
						<div class="title">手机通讯</div>
						<div class="e">Mobile communication</div>
						<img class="add" src="@/assets/images/home_add_icon.png"/>
					</div>
					<div class="bg"></div>
					<img class="up" src="@/assets/images/home_pic_up_1.png"/>
				</div>
				<div class="card">
					<div class="info">
						<img class="icon" src="@/assets/images/home_icon_2.png"/>
						<div class="title">珠宝首饰</div>
						<div class="e">Jewelry</div>
						<img class="add" src="@/assets/images/home_add_icon.png"/>
					</div>
					<div class="bg"></div>
					<img class="up" src="@/assets/images/home_pic_up_2.png"/>
				</div>
				<div class="card">
					<div class="info">
						<img class="icon" src="@/assets/images/home_icon_3.png"/>
						<div class="title">美妆护肤</div>
						<div class="e">Beauty and skincare</div>
						<img class="add" src="@/assets/images/home_add_icon.png"/>
					</div>
					<div class="bg"></div>
					<img class="up" src="@/assets/images/home_pic_up_3.png"/>
				</div>
				<div class="card">
					<div class="info">
						<img class="icon" src="@/assets/images/home_icon_4.png"/>
						<div class="title">箱包</div>
						<div class="e">luggage and bags</div>
						<img class="add" src="@/assets/images/home_add_icon.png"/>
					</div>
					<div class="bg"></div>
					<img class="up" src="@/assets/images/home_pic_up_4.png"/>
				</div>
			</div>
		</div>
		
		<!-- <div class="news-box">
			<div class="title-box">
				<img src="@/assets/images/title_2.png"/>
			</div>
			
			<div class="tab">
				<div v-for="item in tabs" class="item" :class="{ 'active': tabActive === item.dictValue }"
					@click="changeType(item.dictValue)">
					<span>{{ item.dictLabel }}</span>
				</div>
			</div>
			
			<div class="list">
				<div class="item" v-for="(item, index) in news" @click="goDetail(item, index)">
					<img :src="item.pic" style="object-fit: cover;">
					<h3>{{ item.title }}</h3>
					<div class="info">
						<span class="time">{{ item.pushDate }}</span>
						<span class="form">{{ item.mediaChannel }}</span>
					</div>
					<div class="des">{{ item.excerpt }}</div>
				</div>
			</div>
					
			<div class="more" @click="goList()">MORE</div>
		</div> -->
		
		<div class="box-3">
			<div class="in">
				<div class="title">每一次消费都值得期待</div>
				<div class="sub">Authentic product guarantee</div>
				<div class="info">
					<p>为提升购物体验，鹿优选提供快速且高效的物流服务，确保货品安全、迅速地送达您手中。</p>
					<p style="margin-bottom: 24px;">我们的目标是通过高效的服务和质量保证，使每一次购物都成为一次愉快而满意的体验。</p>
					<p>选择鹿优选，享受便捷、智能的现代购物之旅，让每一次消费都值得期待。</p>
				</div>
			</div>
		</div>
		
		<div class="box-4">
			<div class="in">
				<div class="phone">
					<img src="@/assets/images/phone_home_v2.png"/>
				</div>
				<div class="right">
					<div class="title">严选商品 正品保证</div>
					<p>我们的产品系列丰富多样，涵盖时尚、家居、科技等多个领域，与众多国际知名品牌紧密合作，确保每件商品都是正品。</p>
					<img src="@/assets/images/icons.png"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { queryListFromH5, getNewsTab } from '@/axios/api.js'
export default {
	data() {
		return {
			news:[],
			tabs:[],
			tabActive:'',
		}
	},
	created() {
		getNewsTab().then(res => {
			this.tabs = res.data.data
			this.tabActive = this.tabs[0].dictValue
		
			this.getNews()
		})
	},
	mounted() {

	},
	computed: {},
	methods: {
		goList() {
			this.$router.push('/news')
		},
		goDetail(item, index) {
			if(item.jumpType === '外部链接'){
				window.open(item.outLink)
			}else{
				this.$router.push(`/detail?id=${item.id}&tab=${this.tabActive}&nodeNum=${index + 1}`)
			}
		},
		getNews() {
			this.news = []
			let params = {
				pageNum: 1,
				pageSize: 6,
				tab: this.tabActive,
				topUp:1,
			}
			queryListFromH5(params).then(res => {
				this.news = res.data.data.list
			})
		},
		changeType(dictValue) {
			this.tabActive = dictValue
			this.getNews()
		},
		change(index) {
			this.activeIndex = index
		},
		download(type){
			if(type === 'android'){
				window.open('https://package.luyouxuan.com/package/LuYouXuan.apk')
			}else if(type === 'ios'){
				window.open('https://apps.apple.com/cn/app/id6636531470')
			}
		}
	},
}
</script>

<style scoped lang="less">
	.title-box{
		margin-bottom: 40px;
		img{
			display: block;
			margin: 0 auto;
			width: auto;
			height: 84px;
		}
	}
	.home{
		padding-top: 80px;
	}
	.banner{
		height: 715px;
		background: #FF4F6A url("../../assets/images/banner.png") no-repeat center center;
		background-size: auto 100%;
		.in{
			width: 1180px;
			height: 100%;
			box-sizing: border-box;
			margin: 0 auto;
			display: flex;
			padding-top: 420px;
			position: relative;
			.btn{
				height: 50px;
				border-radius: 4px;
				display: flex;
				align-items: center;
				margin-right: 16px;
				padding: 0 10px;
				box-sizing: border-box;
				cursor: pointer;
				transition: all 0.3s;
				&:hover{
					opacity: 0.8;
				}
				img{
					width: 40px;
					height: auto;
					margin-right: 10px;
				}
				.text{
					display: flex;
					flex-direction: column;
					.t1{
						font-size: 12px;
						line-height: 1;
					}
					.t2{
						font-size: 18px;
						line-height: 1;
					}
				}
			}
			.ios{
				background: #fff;
			}
			.android{
				border: #fff 1px solid;
				.text{
					color:#fff;
				}
			}
			
			.icon1{
				width: 86px;
				height: auto;
				position: absolute;
				left: 950px;
				top: 90px;
				animation: floatAnimation 4s infinite;
			}
			.icon2{
				width: 58px;
				height: auto;
				position: absolute;
				left: 1000px;
				top: 180px;
				animation: floatAnimation 5s infinite;
			}
			.icon3{
				width: 58px;
				height: auto;
				position: absolute;
				left: 470px;
				top: 160px;
				animation: floatAnimation 6s infinite;
			}
			.icon4{
				width: 52px;
				height: auto;
				position: absolute;
				left: 490px;
				top: 290px;
				animation: floatAnimation 3s infinite;
			}
			.icon5{
				width: 186px;
				height: auto;
				position: absolute;
				left: 410px;
				top: 390px;
				animation: floatAnimation 5s infinite;
			}
		}
	}
	.box-1{
		padding: 60px 0 110px 0;
		.card-box{
			width: 1180px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			.card{
				
				overflow: hidden;
				width: 295px;
				height: 600px;
				position: relative;
				&:nth-child(1){
					background: url("../../assets/images/home_pic_1.png") no-repeat center center;
					background-size: cover;
				}
				&:nth-child(2){
					background: url("../../assets/images/home_pic_2.png") no-repeat center center;
					background-size: cover;
				}
				&:nth-child(3){
					background: url("../../assets/images/home_pic_3.png") no-repeat center center;
					background-size: cover;
				}
				&:nth-child(4){
					background: url("../../assets/images/home_pic_4.png") no-repeat center center;
					background-size: cover;
				}
				
				.info{
					position: absolute;
					left: 0;
					top: 0;
					width: 100%;
					height: 100%;
					z-index: 4;
					box-sizing: border-box;
					padding: 120px 0 0 40px;
					transition: all 0.3s;
					.icon{
						width: 40px;
						height: 40px;
						margin-bottom: 30px;
						opacity: 0.6;
					}
					.title{
						color: #fff;
						font-size: 24px;
						opacity: 0.6;
						margin-bottom: 8px;
					}
					.e{
						color: #fff;
						font-size: 18px;
						opacity: 0.6;
						margin-bottom: 60px;
					}
					.add{
						width: 20px;
						height: 20px;
						opacity: 0.6;
					}
				}
				
				.bg{
					position: absolute;
					left: 0;
					width: 100%;
					height: 100%;
					z-index: 3;
					background: #FF4F6A;
					top:600px;
					transition: all 0.3s;
				}
				
				.up{
					width: 100%;
					height: auto;
					left: 0;
					bottom: -295px;
					position: absolute;
					z-index: 4;
					transition: all 0.6s;
				}
				
				&:hover{
					.bg{
						top:0px;
					}
					
					.up{
						bottom: 0px;
					}
					
					.info{
						.icon{
							opacity: 1;
						}
						.title{
							opacity: 1;
						}
						.e{
							opacity: 1;
						}
						.add{
							opacity: 1;
						}
					}
				}
			}
		}
	}
	.news-box {
		padding: 60px 0;
		background: #fff url('../../assets/images/news_bg.png') top center no-repeat;
		background-size: 100% auto;
	
		.tab {
			width: 1180px;
			margin: 0 auto 28px auto;
			display: flex;
			align-items: center;
	
			.item {
				margin-right: 20px;
				border-radius: 66px;
				display: flex;
				align-items: center;
				cursor: pointer;
				background: #fff;
				height: 66px;
				padding: 0 40px;

	
				span {
					color: #FF4F6A;
					font-size: 26px;
					font-weight: 500;
				}
	
				&.active {
					background: #FF4F6A;
					span {
						color: #fff;
					}
				}
			}
		}
	
		.list {
			width: 1196px;
			margin: 0 auto 50px auto;
			display: flex;
			flex-wrap: wrap;
	
			.item {
				width: 382px;
				height: 370px;
				padding: 16px;
				box-sizing: border-box;
				background: #fff;
				margin: 0 8px 40px 8px;
				cursor: pointer;
	
				img {
					width: 100%;
					height: 148px;
				}
	
				h3 {
					margin-bottom: 12px;
					font-size: 18px;
				}
	
				.info {
					margin-bottom: 12px;
	
					span {
						font-size: 12px;
	
						&.time {
							color: #AEB3C0;
							margin-right: 16px
						}
					}
				}
	
				.des {
					color: #AEB3C0;
					font-size: 15px;
				}
			}
		}
	
		.more {
			color: #AEB3C0;
			font-size: 18px;
			border-radius: 40px;
			border: #C3C3C3 1px solid;
			height: 40px;
			width: 180px;
			display: flex;
			margin: 0 auto;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			background: rgba(255,255,255,0);
			transition: all 0.3;
			&:hover{
				background: rgba(255,255,255,1);
			}
		}
	}

	.box-3{
		height: 548px;
		background: url("../../assets/images/box_bg.png") no-repeat center center;
		background-size: 100% auto;
		transition: all 0.5s;
		&:hover{
			background-size: 130% auto;
		}
		
		.in{
			color: #fff;
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 100%;
			height: 100%;
			background: linear-gradient(to bottom, #FF4F6A 0%, rgba(255,79,106, 0) 100%);
		}
		.title{
			font-size: 40px;
			font-weight: bold;
			padding-top: 80px;
			line-height: 1;
		}
		.sub{
			font-size: 22px;
			font-weight: 400;
			text-transform: uppercase;
			margin-bottom: 64px;
		}
		p{
			text-align: center;
			font-size: 20px;
			font-weight: 400;
		}
	}

	.box-4{
		background: url("../../assets/images/box_4_bg.png") repeat-x bottom left;
		background-size: auto 208px;
		.in{
			display: flex;
			width: 1300px;
			height: 785px;
			margin: 0 auto;
			box-sizing: border-box;
		}
		.phone{
			padding-top: 54px;
			img{
				width: 574px;
				height: auto;
				animation: floatAnimation 3s infinite;
			}
		}
		.right{
			padding-top: 230px;
			margin-left: 118px;
			.title{
				color: #FF4F6A;
				font-size: 48px;
				font-weight: bold;
				margin-bottom: 20px;
			}
			p{
				width: 490px;
				font-size: 20px;
				color: #545454;
				margin-bottom: 96px;
			}
			img{
				width: 540px;
				height: auto;
				margin-left: -20px;
			}
		}
	}
	
	@keyframes floatAnimation {
	  0% {
	    transform: translateY(0);
	  }
	  50% {
	    transform: translateY(30px);
	  }
	  100% {
	    transform: translateY(0);
	  }
	}
</style>
